<template>
    <div>
        <!-- * choose between upgrade or credit pack (upgrade goes to pricing page & if user plan was starter the not enough credit modal will be shown) -->
        <PricingCreditPackChooseDialog @click:continue="openCreditPackDialog" />
        <!-- * credit pack stuff -->
        <PricingCreditPackDialog />
    </div>
</template>

<script setup lang="ts">
import PricingCreditPackChooseDialog from "./PricingCreditPackChooseDialog.vue";
import PricingCreditPackDialog from "./PricingCreditPackDialog.vue";

const { showCreditPackDialog } = storeToRefs(usePricingStore());

function openCreditPackDialog() {
    showCreditPackDialog.value = true;
}
</script>
